export const VIEWS = {
  LIST_VIEW: 'listView',
  NEW_MESSAGE_VIEW: 'newMessageView',
}
